/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import {
    createReducer,
    on,
} from '@ngrx/store';

import { setControllerSite } from './controller-site.actions';

import {
    controllerSiteInitialState,
    IControllerSiteState,
} from './controller-site.state';

export const controllerSiteStateReducer = createReducer(
    controllerSiteInitialState,
    on(
        setControllerSite,
        (state: IControllerSiteState, action): IControllerSiteState => ({
            ...state,
            ...action.controllerSiteState,
        }),
    ),
);
